import dayjs from 'dayjs';
import { type DateRange, type PreviousPeriods } from '../types';

export const calculatePreviousPeriods = (dateRange: DateRange): PreviousPeriods => {
  const monthsBetweenStartDateAndEndDate =
    dayjs(dateRange.endDate)
      .startOf('month')
      .diff(dayjs(dateRange.startDate).startOf('month'), 'month') + 1;
  const previousPeriodStart = dayjs(dateRange.startDate)
    .subtract(monthsBetweenStartDateAndEndDate, 'month')
    .toDate();
  const previousPeriodEnd = dayjs(dateRange.startDate).subtract(1, 'day').toDate();
  const previousYearStart = dayjs(dateRange.startDate).subtract(1, 'year').toDate();
  const previousYearEnd = dayjs(dateRange.endDate).subtract(1, 'year').toDate();

  return {
    previousPeriodStart,
    previousPeriodEnd,
    previousYearStart,
    previousYearEnd,
  };
};
